module.exports = __webpack_public_path__ + "static/magic_missile-61680fdc42dae7a4fff03ac23a49d408.png";